import { DateTime } from 'luxon';

import { TaskTypesEnum } from '@/bundles/Tasks/enums/TaskTypesEnum';
import { ITask, ITaskRelatedRecord } from '@/bundles/Tasks/interfaces/ITask';
import { Nullable } from '@/utils/types';
import { ITaskCreateUpdate, ITaskCreateUpdatePayload } from '@/bundles/Tasks/interfaces/ITaskCreateUpdate';

export class TaskCreateUpdateDTO {
  title: string;
  type: TaskTypesEnum;
  assignee: number;
  due_date: Date; // Date in local timezone
  description: string;
  marketing: boolean;
  schedule?: string; // rrule expression
  related_records: ITaskRelatedRecord[];
  collaborators: number[];
  team_ids: number[];
  priority: number;
  recurrent_group_id?: string; // ID to group recurrent tasks

  constructor (entity: Nullable<ITaskCreateUpdate | ITask> = null) {
    this.title = entity?.title || '';
    this.type = entity?.type || TaskTypesEnum.call;
    this.assignee = entity?.assignee || 0;
    this.due_date = entity?.due_date ? new Date(entity.due_date) : new Date(new Date().setHours(9, 0, 0, 0));
    this.description = entity?.description || '';
    this.marketing = entity?.marketing || false;
    this.priority = entity?.priority || 1;

    if (entity?.schedule) {
      this.schedule = entity.schedule;
      this.recurrent_group_id = entity.recurrent_group_id;
    }

    this.related_records = entity && 'related_records' in entity ? entity.related_records || [] : [];
    this.collaborators = entity?.collaborators || [];
    this.team_ids = entity?.team_ids || [];
  }

  toJSON (): ITaskCreateUpdatePayload {
    return {
      title: this.title,
      type: this.type,
      assignee: this.assignee,
      due_date: DateTime.fromJSDate(this.due_date).toUTC().toISO(),
      description: this.description,
      marketing: this.marketing,
      priority: this.priority,
      schedule: this.schedule,
      related_records: this.related_records,
      collaborators: this.collaborators,
      team_ids: this.team_ids,
      recurrent_group_id: this.recurrent_group_id,
    };
  }
}
